import _objectSpread from "/opt/graphistry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "/opt/graphistry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/opt/graphistry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import React, { useState, useEffect } from 'react';
import { styled } from "@mui/material/styles";
import Grid from '@mui/material/Grid';
import List from '@mui/material/List';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import Checkbox from '@mui/material/Checkbox';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Chip from '@mui/material/Chip';
import Autocomplete from '@mui/material/Autocomplete';
import styles from '../styles/file-uploader.less';
import logger from '../utils/logger';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var log = logger.createLogger('TransferList');
var Root = styled("div")(function (_ref) {
  var theme = _ref.theme;
  return {
    margin: 'auto'
  };
});
var CardHeaderStyle = styled("div")(function (_ref2) {
  var theme = _ref2.theme;
  return {
    padding: theme.spacing(1, 2),
    background: theme.palette.background.default
  };
});
var ListStyle = styled("div")(function (_ref3) {
  var theme = _ref3.theme;
  return {
    //width: 200,
    height: 230,
    backgroundColor: theme.palette.background.paper,
    overflow: 'auto'
  };
});
var ButtonStyle = styled("div")(function (_ref4) {
  var theme = _ref4.theme;
  return {
    margin: theme.spacing(0.5, 0)
  };
});
function not(a, b) {
  return a.filter(function (value) {
    return b.indexOf(value) === -1;
  });
}
function intersection(a, b) {
  return a.filter(function (value) {
    return b.indexOf(value) !== -1;
  });
}
function union(a, b) {
  return [].concat(_toConsumableArray(a), _toConsumableArray(not(b, a)));
}
export function TransferListRow(_ref5) {
  var source = _ref5.source,
    _ref5$destinations = _ref5.destinations,
    destinations = _ref5$destinations === void 0 ? [] : _ref5$destinations,
    table = _ref5.table,
    _ref5$allowedSources = _ref5.allowedSources,
    allowedSources = _ref5$allowedSources === void 0 ? [] : _ref5$allowedSources,
    onChange = _ref5.onChange,
    setHyperedgeBindings = _ref5.setHyperedgeBindings;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    checked = _useState2[0],
    setChecked = _useState2[1];
  var _useState3 = useState(destinations),
    _useState4 = _slicedToArray(_useState3, 2),
    left = _useState4[0],
    setLeft = _useState4[1];
  var _useState5 = useState(table ? Object.keys(table.dtypes).filter(function (v) {
      return destinations.indexOf(v) === -1;
    }) : []),
    _useState6 = _slicedToArray(_useState5, 2),
    right = _useState6[0],
    setRight = _useState6[1];
  var leftChecked = intersection(checked, left);
  var rightChecked = intersection(checked, right);

  //update bindings on destinations (left) changing
  useEffect(function () {
    if (left.length != destinations.length || intersection(left, destinations).length != destinations.length) {
      setHyperedgeBindings(function (hyperedges) {
        var edgesCopy = _objectSpread({}, hyperedges.opts.EDGES);
        edgesCopy[source] = left;
        return _objectSpread(_objectSpread({}, hyperedges), {}, {
          opts: _objectSpread(_objectSpread({}, hyperedges.opts), {}, {
            EDGES: edgesCopy
          })
        });
      });
    }
  }, [left]);
  var handleToggle = function handleToggle(value) {
    return function () {
      var currentIndex = checked.indexOf(value);
      var newChecked = _toConsumableArray(checked);
      if (currentIndex === -1) {
        newChecked.push(value);
      } else {
        newChecked.splice(currentIndex, 1);
      }
      setChecked(newChecked);
    };
  };
  var numberOfChecked = function numberOfChecked(items) {
    return intersection(checked, items).length;
  };
  var handleToggleAll = function handleToggleAll(items) {
    return function () {
      if (numberOfChecked(items) === items.length) {
        setChecked(not(checked, items));
      } else {
        setChecked(union(checked, items));
      }
    };
  };
  var handleAllRight = function handleAllRight() {
    setRight(right.concat(left));
    setLeft([]);
  };
  var handleCheckedRight = function handleCheckedRight() {
    setRight(right.concat(leftChecked));
    setLeft(not(left, leftChecked));
    setChecked(not(checked, leftChecked));
  };
  var handleCheckedLeft = function handleCheckedLeft() {
    setLeft(left.concat(rightChecked));
    setRight(not(right, rightChecked));
    setChecked(not(checked, rightChecked));
  };
  var handleAllLeft = function handleAllLeft() {
    setLeft(left.concat(right));
    setRight([]);
  };
  var customList = function customList(title, items) {
    var disallowed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var headerClass = arguments.length > 3 ? arguments[3] : undefined;
    return /*#__PURE__*/_jsxs(Card, {
      children: [/*#__PURE__*/_jsx(CardHeaderStyle, {
        children: /*#__PURE__*/_jsx(CardHeader, {
          className: "".concat(headerClass),
          avatar: '',
          subheader: title
        })
      }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx(ListStyle, {
        children: /*#__PURE__*/_jsxs(List, {
          dense: true,
          component: "div",
          role: "list",
          children: [items.map(function (value) {
            var labelId = "transfer-list-all-item-".concat(value, "-label");
            return /*#__PURE__*/_jsxs(ListItem, {
              role: "listitem",
              button: true,
              onClick: handleToggle(value),
              disabled: disallowed.indexOf(value) > -1,
              children: [/*#__PURE__*/_jsx(ListItemIcon, {
                children: /*#__PURE__*/_jsx(Checkbox, {
                  color: "primary",
                  checked: checked.indexOf(value) !== -1,
                  tabIndex: -1,
                  disableRipple: true,
                  inputProps: {
                    'aria-labelledby': labelId
                  }
                })
              }), /*#__PURE__*/_jsx(ListItemText, {
                id: labelId,
                primary: "".concat(value)
              })]
            }, value);
          }), /*#__PURE__*/_jsx(ListItem, {})]
        })
      })]
    });
  };
  return /*#__PURE__*/_jsx(Root, {
    children: /*#__PURE__*/_jsxs(Row, {
      className: "".concat(styles['shaper-edge-row']),
      children: [/*#__PURE__*/_jsx(Col, {
        className: styles['shaper-source-col'],
        children: /*#__PURE__*/_jsxs(Card, {
          children: [/*#__PURE__*/_jsx(CardHeaderStyle, {
            children: /*#__PURE__*/_jsx(CardHeader, {
              className: "".concat(styles['hyperedge-from-header']),
              avatar: '',
              subheader: 'edge "from" column',
              variant: "primary"
            })
          }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx(List, {
            style: {
              'padding': '1em'
            },
            children: /*#__PURE__*/_jsx(Autocomplete, {
              value: source,
              options: table && table.dtypes ? Object.keys(table.dtypes) : [],
              includeInputInList: true,
              disableClearable: true,
              openOnFocus: true,
              autoHighlight: true,
              renderInput: function renderInput(params) {
                return /*#__PURE__*/_jsx(TextField, _objectSpread(_objectSpread({
                  variant: "outlined"
                }, params), {}, {
                  label: "",
                  margin: "normal"
                }));
              },
              getOptionDisabled: function getOptionDisabled(option) {
                return allowedSources.indexOf(option) === -1;
              },
              onChange: function onChange(event, newValue) {
                setHyperedgeBindings(function (hyperedges) {
                  //preserve order
                  var edgesCopy = {};
                  for (var _i = 0, _Object$entries = Object.entries(hyperedges.opts.EDGES); _i < _Object$entries.length; _i++) {
                    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
                      key = _Object$entries$_i[0],
                      value = _Object$entries$_i[1];
                    edgesCopy[key === source ? newValue : key] = value;
                  }
                  return _objectSpread(_objectSpread({}, hyperedges), {}, {
                    opts: _objectSpread(_objectSpread({}, hyperedges.opts), {}, {
                      EDGES: edgesCopy
                    })
                  });
                });
              }
            })
          })]
        })
      }), /*#__PURE__*/_jsx(Col, {
        className: styles['shaper-dest-col'],
        children: customList('edge "to" columns', left, [], styles['hyperedge-dest-active-header'])
      }), /*#__PURE__*/_jsx(Col, {
        md: {
          span: 1
        },
        className: styles['shaper-dest-button-col'],
        children: /*#__PURE__*/_jsxs(Grid, {
          container: true,
          direction: "column",
          alignItems: "center",
          children: [/*#__PURE__*/_jsx(ButtonStyle, {
            children: /*#__PURE__*/_jsx(Button, {
              variant: "outlined",
              size: "small",
              onClick: handleAllRight,
              disabled: left.length === 0,
              "aria-label": "move all right",
              children: "\u226B"
            })
          }), /*#__PURE__*/_jsx(ButtonStyle, {
            children: /*#__PURE__*/_jsx(Button, {
              variant: "outlined",
              size: "small",
              onClick: handleCheckedRight,
              disabled: leftChecked.length === 0,
              "aria-label": "move selected right",
              children: ">"
            })
          }), /*#__PURE__*/_jsx(ButtonStyle, {
            children: /*#__PURE__*/_jsx(Button, {
              variant: "outlined",
              size: "small",
              onClick: handleCheckedLeft,
              disabled: rightChecked.length === 0,
              "aria-label": "move selected left",
              children: "<"
            })
          }), /*#__PURE__*/_jsx(ButtonStyle, {
            children: /*#__PURE__*/_jsx(Button, {
              variant: "outlined",
              size: "small",
              onClick: handleAllLeft,
              disabled: right.length === 0,
              "aria-label": "move all left",
              children: "\u226A"
            })
          })]
        })
      }), /*#__PURE__*/_jsx(Col, {
        className: styles['shaper-dest-available-col'],
        children: customList('unused columns', right, [source], styles['hyperedge-dest-inactive-header'])
      }), /*#__PURE__*/_jsx(Col, {
        md: {
          span: 1
        },
        style: {
          marginTop: '2em'
        },
        children: /*#__PURE__*/_jsx(Button, {
          variant: "outlined",
          size: "small",
          className: styles['shaper-delete'],
          onClick: function onClick() {
            setHyperedgeBindings(function (hyperedges) {
              //preserve order
              var edgesCopy = {};
              for (var _i2 = 0, _Object$entries2 = Object.entries(hyperedges.opts.EDGES); _i2 < _Object$entries2.length; _i2++) {
                var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
                  key = _Object$entries2$_i[0],
                  value = _Object$entries2$_i[1];
                if (key != source) {
                  edgesCopy[key] = value;
                }
              }
              return _objectSpread(_objectSpread({}, hyperedges), {}, {
                opts: _objectSpread(_objectSpread({}, hyperedges.opts), {}, {
                  EDGES: edgesCopy
                })
              });
            });
          },
          children: /*#__PURE__*/_jsx("i", {
            style: {
              fontSize: '18px'
            },
            className: "fa fa-trash"
          })
        })
      })]
    })
  });
}